import {
    IconAddressBook, IconApps, IconBuilding, IconCheckbox, IconClockPlay, IconDevices, IconFileEuro, IconFileInvoice,
    IconKey, IconLayoutKanban, IconRoute, IconShieldCheck, IconUser, IconWorldWww,
    type Icon,
} from '@tabler/icons-react';
import type { TypeEntityKind } from '@/types/ui/types.ui.navigation';

export const ENTITY_ICON: Record<TypeEntityKind, Icon> = {
    service: IconApps,
    apiKey: IconKey,
    route: IconRoute,
    origin: IconWorldWww,
    accessRule: IconShieldCheck,
    user: IconUser,
    device: IconDevices,
    session: IconClockPlay,
    organization: IconBuilding,
    customer: IconAddressBook,
    project: IconLayoutKanban,
    task: IconCheckbox,
    quote: IconFileEuro,
    invoice: IconFileInvoice,
};
